import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { theme } from './styles/theme';

// Pages
import ColorPicker from './pages/ColorPicker';
import GradientCreator from './pages/GradientCreator';
import ColorPalette from './pages/ColorPalette';
import ColorComparator from './pages/ColorComparator';
import ColorPatternGenerator from './pages/ColorPatternGenerator';

// Components
import Layout from './components/Layout';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<ColorPicker />} />
            <Route path="/gradient" element={<GradientCreator />} />
            <Route path="/palette" element={<ColorPalette />} />
            <Route path="/compare" element={<ColorComparator />} />
            <Route path="/pattern" element={<ColorPatternGenerator />} />
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  );
}

export default App;
